import React from 'react';
import ReactDom from 'react-dom';

class Modal extends React.Component {
  constructor() {
    super();
    this.el = document.getElementById('modal-root');
  }
  componentDidMount() {
    document.querySelector('.modalBox input, .modalBox button').focus();
  }
  componentWillReceiveProps() {
  }
  render() {
    return ReactDom.createPortal(
      <div className="modalBack">
        <div className="modalBox">
          { this.props.children }
        </div>
      </div>,
      this.el
    );
  }
}

export default Modal;
